import { createFileRoute } from '@tanstack/react-router';

import { Platforms } from '@mint-sdk/api-bff';
import { Metadata } from '@mint-sdk/api-mdm';
import { OmniSocket } from '@mint-sdk/api-omni';
import { io } from 'socket.io-client';

const SOCKET_SERVICE = '/api/socketio-service/socket-io/';
const URL = `${
  globalThis.location.port !== '' && globalThis.location.port !== '443'
    ? 'ws'
    : 'wss'
}://${globalThis.location.hostname}${
  globalThis.location.port === '443' ? '' : `:${globalThis.location.port}`
}`;

const establishSocketConnection = async (accessToken: string) => {
  const url = `${URL}${SOCKET_SERVICE}tasks`;
  const rawSocket = io(url, {
    transports: ['websocket'],
    path: SOCKET_SERVICE,
    query: {
      authorization: encodeURIComponent(accessToken),
    },
  });

  OmniSocket.socket.provideClient(rawSocket);
};

export const Route = createFileRoute(
  '/_secured/campaign/$campaignId/settings/omni/$platform/$tileId',
)({
  loader: async ({ context, params }) => {
    const i18n = await context.getInstance('i18n', '@mint/routing');
    await context.getInstance('i18n', '@myn/omni-settings');
    const isSettingsV2 = await context.isFlagEnabled(
      '@mint/arm',
      'settingsMint2',
    );
    let platformLabel = '';

    const authService = await context.getInstance('auth');
    const accessToken = authService.getAccessToken();
    if (accessToken) {
      await establishSocketConnection(accessToken);
      OmniSocket.enterTileRoom({ tileId: params.tileId });
    }

    if (isSettingsV2) {
      const [, profile] = await context.serviceLocator.getInstance('profile');
      const companyId = profile?.getProfileData()?.profile.company.id;
      const platformsMint2 = await context.prefetchQuery(
        Metadata.getContextMetadataQueryOptions({
          params: {
            fieldUrnIds: ['platform_v2'],
            companyId,
            context: 'integration',
          },
        }),
      );

      platformLabel =
        platformsMint2[
          Object.keys(platformsMint2).find((key) =>
            key.includes('platform_v2'),
          ) ?? ''
        ]?.options.find((option) => option.value.includes(params.platform))
          ?.label ?? '';
    } else {
      const platforms = isSettingsV2
        ? []
        : await context.prefetchQuery({
            ...Platforms.listQueryOptions({
              params: { excludeDeleted: true, excludeNotIntegrated: false },
            }),
            staleTime: 1000 * 60 * 5,
          });

      platformLabel =
        platforms.find((platform) => platform.platform === params.platform)
          ?.label ?? '';
    }

    const title = i18n.t('Settings - {{platform}} | MINT', {
      platform: platformLabel || params.platform,
    });

    return { title };
  },
  head: ({ loaderData }) => ({
    meta: [
      {
        title: loaderData?.title,
      },
    ],
  }),
  onLeave: () => {
    OmniSocket.socket.getClient().disconnect?.();
  },
});
